import { render, staticRenderFns } from "./DeleteTaskPopup.vue?vue&type=template&id=4fb5716a&scoped=true&"
import script from "./DeleteTaskPopup.vue?vue&type=script&lang=ts&"
export * from "./DeleteTaskPopup.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteTaskPopup.vue?vue&type=style&index=0&id=4fb5716a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb5716a",
  null
  
)

export default component.exports